<template>
    <div class="flex flex-col gap-2">
        <UCheckbox
            v-for="o in options"
            :key="o.value"
            :model-value="values.includes(o.value)"
            @update:model-value="toggle(o, $event)"
        >
            <template #label>
                <span class="flex items-center gap-1.5">
                    <span :class="[o.dot, 'inline-block size-1.5 flex-shrink-0 rounded-full']" aria-hidden="true" />
                    {{ o.name }}
                </span>
            </template>
        </UCheckbox>
    </div>
</template>

<script setup lang="ts">
import { CallStatus } from '~/types/call'
import type { Filter } from '~/types/filter'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()

const options = [
    { name: 'New', value: CallStatus.new, dot: 'bg-rose-500' },
    { name: 'Active', value: CallStatus.active, dot: 'bg-blue-500' },
    { name: 'On Hold', value: CallStatus.onHold, dot: 'bg-amber-500' },
    { name: 'Resolved', value: CallStatus.resolved, dot: 'bg-emerald-500' },
    { name: 'Unresolved', value: CallStatus.unresolved, dot: 'bg-orange-500' },
    { name: 'False Call', value: CallStatus.falseCall, dot: 'bg-red-500' },
    { name: 'Timed Out', value: CallStatus.timedOut, dot: 'bg-gray-500' },
]

const values = computed<string[]>(() => (Array.isArray(props.filter.value) ? props.filter.value : []))

function toggle(opt: { name: string; value: string }, on: boolean) {
    const next = on ? [...values.value, opt.value] : values.value.filter(v => v !== opt.value)
    const selected = options.filter(o => next.includes(o.value))
    emit('update:filter', { ...props.filter, value: next.length ? next : undefined, selected: selected.length ? selected : undefined })
}
</script>
